import * as React from "react";
import { Icon } from "../../../../../../ui/IconSVG";
import { Wrapper } from "./Wrapper";

export const HomeIcon = props => (
  <Wrapper {...props}>
    <Icon type="home" />
  </Wrapper>
);
